<template>
	<div class="sys">
		<el-image :src="noLogoImg" class="sys-logo pointer" @click="router.push(logoLink)"></el-image>
		<div class="sys-name" :style="sysnameStyle">{{ sysNameOfCn }}</div>
	</div>
</template>

<script lang="ts" setup>
import variables from '@scss/var.module.scss'
import noLogoImg from '@/assets/images/logo.png'
import { useRouter } from 'vue-router'

const router = useRouter()
const props = defineProps({
	logoLink: {
		type: Object,
		default: () => {
			return { name: 'home' }
		},
	},
	sysNameOfCn: {
		type: String,
		default: '',
	},
	sysnameColor: {
		type: String,
		default: variables.colorDark,
	},
})

const sysnameStyle = computed(() => ({ color: props.sysnameColor }))
</script>

<style lang="scss" scoped>
$textColor: #303030;
$logoSize: 36px;

.sys {
	display: flex;
	align-items: center;
	&-logo {
		display: inline-block;
		width: $logoSize;
		height: $logoSize;
		line-height: $logoSize;
		border-radius: 50%;
	}
	&-name {
		margin-left: 14px;
		font-size: 20px;
		font-weight: bold;
		letter-spacing: 2px;
	}
}
</style>
